import React, { useEffect } from 'react';
import '../css/VisualizarServicosDisponiveis.css';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { GiDetonator } from 'react-icons/gi';

const servicos = [
  { id: 1, nome: 'Mototáxi', imagem: '/imagens/imagens_servicos/moto-taxi.png' },
  { id: 2, nome: 'Encomendas Pequenas', imagem: '/imagens/imagens_servicos/encomendas.png' },
  { id: 4, nome: 'Material de Construção', imagem: '/imagens/imagens_servicos/cimento.png' },
  { id: 5, nome: 'Bebidas', imagem: '/imagens/imagens_servicos/cerveja.png' },
  { id: 6, nome: 'Supermercado', imagem: '/imagens/imagens_servicos/compras.png' },
  { id: 7, nome: 'Banco', imagem: '/imagens/imagens_servicos/banco.png' },
  { id: 8, nome: 'Farmácia', imagem: '/imagens/imagens_servicos/farmacia.png' },
];

function VisualizarServicosDisponiveis() {
  const navigate = useNavigate();

    // Limpa cookies ao entrar na página
    useEffect(() => {
        Cookies.remove('dadosCookies');
    }, []);
      

  
  const handleClick = (servico) => {
    navigate('/mapa', { state: { servicoSelecionado: servico } });
  };

  return (
    <div className="container py-4 d-flex flex-column align-items-center">
      {/* Card do título centralizado e estilizado */}
      <div 
        className="card shadow-lg border-0 mb-4 w-100" 
        style={{ 
          maxWidth: '400px', 
          backgroundColor: '#ff7f50',  // coral (vibrante) 
          borderRadius: '15px',
          boxShadow: '0 4px 15px rgba(255, 127, 80, 0.5)'
        }}
      >
        <div className="card-body text-center py-3">
          <h4 className="fw-bold mb-0 text-white">Serviços Disponíveis</h4>
        </div>
      </div>

      {/* Grid serviços, centralizado e com limite de largura */}
      <div 
        className="row g-3 justify-content-center w-100" 
        style={{ maxWidth: '900px' }}
      >
        {servicos.map((servico) => (
          <div 
            key={servico.id} 
            className="col-6 col-md-4 col-lg-3 d-flex justify-content-center"
          >
            <div 
              className="servico-card text-center p-3 shadow-sm rounded-4 w-100" 
              onClick={() => handleClick(servico)}
              style={{ 
                cursor: 'pointer', 
                background: '#fff', 
                transition: 'transform 0.2s', 
                maxWidth: '160px' 
              }}
            >
            <img 
                src={servico.imagem} 
                alt={servico.nome} 
                className="img-fluid mb-2" 
                style={{ 
                    maxHeight: '100px', 
                    objectFit: 'contain',
                    boxShadow: '0 8px 15px rgba(0,0,0,0.3)', // sombra maior
                    borderRadius: '12px' // arredondar bordas também deixa mais bonito
                }} 
            />

              <p 
                className="servico-nome fw-semibold mb-0" 
                style={{ fontSize: '1rem' }}
              >
                {servico.nome}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VisualizarServicosDisponiveis;
